import { Col, Typography } from 'antd';
const {
  Text
} = Typography;
function UserProfileHeader({
  name,
  type
}) {
  return <Col>
      <div>
        <Text className="h6 name">{name}</Text>
      </div>
      <Text className="type">{type} Profile</Text>
    </Col>;
}
export default UserProfileHeader;